import avatar from "../../img/avatar_placeholder.jpg";
import moment from "moment";
import { Link, useHistory, useLocation, useParams } from "react-router-dom";
import axiosInstance from "../../config/axios-instance";
import { useQuery } from "react-query";
import { LoadingOutlined, FilterOutlined } from "@ant-design/icons";
import {
  Avatar,
  Button,
  Collapse,
  Descriptions,
  Input,
  Pagination,
  Popconfirm,
  Result,
  Select,
  Spin,
  Tooltip,
} from "antd";
import { useState } from "react";
import { DeleteOutlined, InboxOutlined } from "@ant-design/icons";
import { useMutation } from "react-query";
import OrderServices from "../../actions/order-actions/services";
import { MyNotif } from "../../components/NotifIcons/NotifIcons";
import { restoreOption } from "../../actions/my-orders/services";
const { Option } = Select;
const { Panel } = Collapse;

const DirectOrdersCompany = () => {
  const [filterBy, setFilterBy] = useState({
    reference: "",
    client: 0,
    type: 0,
  });
  const [orders, setOrders] = useState<any>(null);
  const [filterLoading, setFilterLoading] = useState(false);
  const [ordersCancel, serOrdersCancel] = useState<any>(null);
  const params = useParams<any>();
  const history = useHistory<any>();

  function useQueryy() {
    return new URLSearchParams(useLocation().search);
  }
  let query = useQueryy();

  const fetchDirectOrders = () => {
    let token = localStorage.getItem("token");
    return axiosInstance({
      method: "get",
      url: `/admin/direct_orders/companies/${params.id}?status=completed&page=${
        query.get("page") || 1
      }`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((res: any) => setOrders(res.data));
  };

  const fetchClients = () => {
    let token = localStorage.getItem("token");
    return axiosInstance({
      method: "get",
      url: `/admin/clients/companies/${params.id}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  };

  const { isLoading: loading, data: clients } = useQuery<any>(
    "clients",
    () => fetchClients(),
    { keepPreviousData: true }
  );
  const { isLoading, isError, data, error } = useQuery(
    ["direct_orders", query.get("page")],
    () => fetchDirectOrders(),
    { keepPreviousData: true }
  );

  const onFilter = (e: any, filters: any, page: number) => {
    e.preventDefault();
    setFilterLoading(true);
    console.log(filterBy.type);
    if (!filters.client && !filters.reference && !filterBy.type) {
      fetchDirectOrders();
      setFilterLoading(false);
    } else {
      let token = localStorage.getItem("token");
      return axiosInstance({
        method: "get",
        url: `/admin/search/direct_orders?reference=${filterBy.reference}&type=${filterBy.type}&ownerId=${filterBy.client}&page=${page}`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then((res: any) => {
        if (filters.type === 0) {
          setOrders(res.data);
          setFilterLoading(false);
        } else {
          serOrdersCancel(res.data);
          setFilterLoading(false);
        }
      });
    }
  };

  const { mutateAsync: deleteOpt, isLoading: deleteLoading } = useMutation(
    OrderServices.deleteOption,
    {
      onSuccess: () => {
        MyNotif("Option deleted successfully.", "success");
      },
    }
  );
  const { mutateAsync: restoreOpt, isLoading: restoreLoading } = useMutation(
    restoreOption,
    {
      onSuccess: () => {
        MyNotif(
          `Option restored successfully. You can check it in order`,
          "success"
        );
      },
    }
  );

  return isLoading ? (
    <div
      className="loading_orders"
      style={{ height: "50vh", width: "50vw", margin: "0 auto" }}
    >
      <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
    </div>
  ) : (
    <>
      <Collapse
        ghost
        expandIcon={() => (
          <FilterOutlined
            style={{ fontSize: 20, verticalAlign: 0, paddingTop: 8 }}
          />
        )}
      >
        <Panel header="Filter Orders" key="1">
          <form
            className="d-flex"
            onSubmit={(e: any) => onFilter(e, filterBy, 1)}
          >
            <Input
              type="text"
              className="w-50 mr-3 rounded"
              placeholder="Order reference"
              value={filterBy.reference}
              onChange={(e) =>
                setFilterBy({ ...filterBy, reference: e.target.value })
              }
            />
            <Select
              loading={loading}
              style={{ borderRadius: 5 }}
              className="w-25 mr-3 select_filter_client"
              placeholder="Order sent by"
              value={+filterBy.client}
              onChange={(x: any) => setFilterBy({ ...filterBy, client: x })}
            >
              <Option value={0}>All clients</Option>
              {clients &&
                clients.data.data.map((client: any, i: number) => (
                  <Option value={client.id} key={i}>
                    {client.name}
                  </Option>
                ))}
            </Select>

            <Select
              loading={loading}
              className="w-25 mr-3 select_filter_client"
              placeholder="Order type"
              value={+filterBy.type}
              onChange={(x: any) => setFilterBy({ ...filterBy, type: x })}
            >
              <Option value={0}>All</Option>
              <Option value={6}>Option Cancelled</Option>
              <Option value={7}>Option Closed</Option>
            </Select>
            <div className="d-flex w-25">
              <Input
                type="submit"
                value="Filter"
                className="w-50 mr-2 rounded"
              />
              <Input
                type="reset"
                value="Clear"
                className="w-50 rounded"
                onClick={(e: any) => {
                  onFilter(e, { reference: "", client: 0, type: 0 }, 1);
                  setFilterBy({ reference: "", client: 0, type: 0 });
                }}
              />
            </div>
          </form>
        </Panel>
      </Collapse>

      {filterBy.type === 0 ? (
        <>
          {" "}
          {filterLoading ? (
            <div
              className="loading_orders"
              style={{ height: "50vh", width: "50vw", margin: "0 auto" }}
            >
              <Spin
                indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
              />
            </div>
          ) : orders && orders.data.length > 0 ? (
            <table className="table">
              <thead>
                <tr>
                  <th>Order Ref</th>
                  <th>Client</th>
                  <th>Name</th>
                  <th>Articles</th>
                  <th>Team</th>
                  <th>Date</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {orders &&
                  orders.data.map((order: any) => (
                    <tr key={order.id}>
                      <td>{order.ref || "n/a"}</td>
                      <td className="d-flex">
                        <div className="d-flex align-items-center">
                          <a
                            key={order.id}
                            className="collab_profile mr-2"
                            style={{
                              backgroundImage: `url(${
                                order.client.logo
                                  ? process.env.REACT_APP_STORAGE_URL +
                                    order.client.logo
                                  : avatar
                              })`,
                            }}
                            //   replace id with the collaborator name
                            id={order.client.name}
                          ></a>
                          <p className="mb-0">{order.client.name}</p>
                        </div>
                      </td>
                      <td>
                        <p className="mb-0">{order.name}</p>
                      </td>
                      <td>
                        <p className="mb-0">{order.articles_count}</p>
                      </td>
                      <td>
                        {order?.collaborators?.length > 0
                          ? order?.collaborators?.map((collab: any) => (
                              <Tooltip
                                title={collab.name}
                                placement="bottom"
                                key={collab.id}
                              >
                                <Avatar
                                  key={collab.id}
                                  alt={collab.name}
                                  src={
                                    collab.logo
                                      ? process.env.REACT_APP_STORAGE_URL +
                                        collab.logo
                                      : "col"
                                  }
                                />
                              </Tooltip>
                            ))
                          : "-"}
                      </td>
                      <td>
                        <p className="mb-0">
                          {moment(order.updated_at).format("MMMM DD YYYY")}
                        </p>
                      </td>
                      <td>
                        <Link to={`${history.location.pathname}/${order.id}`}>
                          See Details
                        </Link>
                      </td>
                    </tr>
                  ))}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan={5}>
                    <Pagination
                      defaultCurrent={orders && orders.current_page}
                      defaultPageSize={10}
                      total={orders && orders.total}
                      hideOnSinglePage
                      responsive
                      onChange={(page: any) =>
                        !filterBy.client && !filterBy.client
                          ? history.push(
                              `/all-clients/${params.id}/${params.tab_key}?page=${page}`
                            )
                          : onFilter(null, filterBy, page)
                      }
                    />
                  </td>
                </tr>
              </tfoot>
            </table>
          ) : (
            <Result
              status="404"
              title="No Orders"
              style={{ width: "100%" }}
              subTitle="Sorry, there's no orders sent with these options."
              extra={
                filterBy.client || filterBy.reference ? (
                  <Button
                    type="primary"
                    onClick={(e: any) => {
                      onFilter(e, { reference: "", client: 0, type: 0 }, 1);
                      setFilterBy({ reference: "", client: 0, type: 0 });
                    }}
                  >
                    Clear Filter
                  </Button>
                ) : null
              }
            />
          )}
        </>
      ) : filterBy.type === 6 ? (
        <>
          {" "}
          {filterLoading ? (
            <div
              className="loading_orders"
              style={{ height: "50vh", width: "50vw", margin: "0 auto" }}
            >
              <Spin
                indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
              />
            </div>
          ) : ordersCancel && ordersCancel.length > 0 ? (
            <table className="table">
              <thead>
                <tr>
                  <th>Option Name</th>
                  <th>Article Name</th>
                  <th>Order Name</th>
                  <th>Delete Date </th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {ordersCancel &&
                  ordersCancel.map((order: any) => (
                    <tr key={order.name}>
                      <td>{order.name}</td>
                      <td>{order.article_name}</td>
                      <td>
                        <p className="mb-0">{order.order_name}</p>
                      </td>
                      <td>
                        <p className="mb-0">
                          {moment(order.updated_at).format("MMMM DD YYYY")}
                        </p>{" "}
                      </td>
                      <td>
                        {" "}
                        <div>
                          <Popconfirm
                            placement="top"
                            title={
                              "Are you sure you want to delete this order ?"
                            }
                            onConfirm={() => deleteOpt(order.id)}
                            okText="Yes"
                            cancelText="No"
                          >
                            <Button
                              type="ghost"
                              size={"middle"}
                              className="mr-2"
                              style={{ borderRadius: "4px" }}
                              icon={
                                <DeleteOutlined style={{ color: "#00468c" }} />
                              }
                              loading={deleteLoading}
                            >
                              Delete
                            </Button>
                          </Popconfirm>
                          <Popconfirm
                            placement="top"
                            title={
                              "Are you sure you want to restore this order ?"
                            }
                            onConfirm={() => restoreOpt(order.id)}
                            okText="Yes"
                            cancelText="No"
                          >
                            <Button
                              size={"middle"}
                              style={{ borderRadius: "4px" }}
                              icon={
                                <InboxOutlined
                                  style={{
                                    color: "#00468c",
                                    verticalAlign: "1px",
                                  }}
                                />
                              }
                              loading={restoreLoading}
                            >
                              Restore
                            </Button>
                          </Popconfirm>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan={5}>
                    {/*   <Pagination
                    defaultCurrent={orders && orders.current_page}
                    defaultPageSize={10}
                    total={orders && orders.total}
                    hideOnSinglePage
                    responsive
                    onChange={(page: any) =>
                      !filterBy.client && !filterBy.client
                        ? history.push(
                            `/all-clients/${params.id}/${params.tab_key}?page=${page}`
                          )
                        : onFilter(null, filterBy, page)
                    }
                  /> */}
                  </td>
                </tr>
              </tfoot>
            </table>
          ) : (
            <Result
              status="404"
              title="No Orders"
              style={{ width: "100%" }}
              subTitle="Sorry, there's no orders sent with these options."
              extra={
                filterBy.client || filterBy.reference ? (
                  <Button
                    type="primary"
                    onClick={(e: any) => {
                      onFilter(e, { reference: "", client: 0, type: 0 }, 1);
                      setFilterBy({ reference: "", client: 0, type: 0 });
                    }}
                  >
                    Clear Filter
                  </Button>
                ) : null
              }
            />
          )}
        </>
      ) : (
        <>
          {" "}
          {filterLoading ? (
            <div
              className="loading_orders"
              style={{ height: "50vh", width: "50vw", margin: "0 auto" }}
            >
              <Spin
                indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
              />
            </div>
          ) : ordersCancel && ordersCancel.length > 0 ? (
            <table className="table">
              <thead>
                <tr>
                  <th>Option Name</th>
                  <th>Article Name</th>
                  {filterBy.client == 0 && <th>Owner</th>}
                  <th>Order Name</th>
                  <th>Delivery date </th>
                </tr>
              </thead>
              <tbody>
                {ordersCancel &&
                  ordersCancel.map((order: any) => (
                    <tr key={order.name}>
                      <td>{order.name}</td>
                      <td className="d-flex">{order.article_name}</td>
                      {filterBy.client == 0 && <td>{order?.client?.name}</td>}
                      <td>
                        <p className="mb-0">{order.order_name}</p>
                      </td>
                      <td>
                        <p className="mb-0">
                          {moment(order?.status?.delivery_date).format(
                            "MMMM DD YYYY"
                          )}
                        </p>{" "}
                      </td>
                    </tr>
                  ))}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan={5}>
                    {/*   <Pagination
                  defaultCurrent={orders && orders.current_page}
                  defaultPageSize={10}
                  total={orders && orders.total}
                  hideOnSinglePage
                  responsive
                  onChange={(page: any) =>
                    !filterBy.client && !filterBy.client
                      ? history.push(
                          `/all-clients/${params.id}/${params.tab_key}?page=${page}`
                        )
                      : onFilter(null, filterBy, page)
                  }
                /> */}
                  </td>
                </tr>
              </tfoot>
            </table>
          ) : (
            <Result
              status="404"
              title="No Orders"
              style={{ width: "100%" }}
              subTitle="Sorry, there's no orders sent with these options."
              extra={
                filterBy.client || filterBy.reference ? (
                  <Button
                    type="primary"
                    onClick={(e: any) => {
                      onFilter(e, { reference: "", client: 0, type: 0 }, 1);
                      setFilterBy({ reference: "", client: 0, type: 0 });
                    }}
                  >
                    Clear Filter
                  </Button>
                ) : null
              }
            />
          )}
        </>
      )}
    </>
  );
};

export default DirectOrdersCompany;
